<style src="./styles/init.css">
</style>

<style lang="scss" src="./styles/index.scss">
</style>

<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>





// WEBPACK FOOTER //
// src/App.vue